"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function () {
  var ownKeys = function (o) {
    ownKeys = Object.getOwnPropertyNames || function (o) {
      var ar = [];
      for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
      return ar;
    };
    return ownKeys(o);
  };
  return function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCheckbox = exports.Container = exports.Label = exports.Input = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.Input = styled_components_1.default.input.attrs({
  type: 'checkbox'
})`
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
`;
exports.Label = styled_components_1.default.span`
  color: ${props => props.theme.colors.gray_602};
  opacity: 0.9;
  line-height: ${props => props.theme.lineHeights[18]};
`;
exports.Container = styled_components_1.default.label`
  display: inline-flex;
  align-items: center;
  position: relative;
  margin-bottom: ${props => props.theme.spacing[7]};
  cursor: pointer;
  font-size: ${props => props.theme.fontSizes[14]};
  user-select: none;
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
  ${props => props.isDisabled && (0, styled_components_1.css)`
      cursor: not-allowed;
    `}
`;
exports.StyledCheckbox = styled_components_1.default.span`
  height: 19px;
  width: 19px;

  background-color: ${props => props.checkboxBg || props.theme.colors.white};
  border: 1px solid;
  border-color: ${props => props.checkboxBorderColor || props.theme.colors.gray_301};
  border-radius: 2px;

  &:hover {
    &:before {
      content: '';
      display: block;
      position: absolute;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-color: ${props => props.theme.colors.primary_700_main};
      opacity: 0.07;
      z-index: -1;
      transform: translate(-50%, -50%);
      left: 9.5px;
      top: 9.5px;
    }
  }
  ${exports.Input}:checked + & {
    background-color: ${props => props.checkboxBgActive || props.theme.colors.primary_700_main};
    border-color: ${props => props.checkboxBgActive || props.theme.colors.primary_700_main};

    &:after {
      content: '';
      display: block;
      position: absolute;
      left: 7px;
      top: 4px;
      width: 3px;
      height: 7px;
      border-style: solid;
      border-color: ${props => props.checkMarkColor || props.theme.colors.white};
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
  }
  ${exports.Input}:indeterminate + & {
    background-color: ${props => props.checkboxBgActive || props.theme.colors.primary_700_main};
    border-color: ${props => props.checkboxBgActive || props.theme.colors.primary_700_main};

    &:after {
      content: '';
      display: block;
      position: absolute;
      left: 6.5px;
      top: 8.5px;
      width: 6px;
      height: 2px;
      border: 0;
      background-color: ${props => props.checkMarkColor || props.theme.colors.white};
    }
  }
  ${exports.Input}:disabled + & {
    background-color: ${props => props.checkboxBgDisabled || props.theme.colors.beige_400};
    &:before {
      display: none;
    }
  }
  & + ${exports.Label} {
    margin-left: ${props => props.theme.spacing[12]};
  }
  ${props => props.theme.isMobile && (0, styled_components_1.css)`
      height: 24px;
      width: 24px;
      ${exports.Input}:checked + & {
        &:after {
          width: 5px;
          height: 9px;
          left: 9px;
          top: 5px;
        }
      }
      ${exports.Input}:indeterminate + & {
        &:after {
          content: '';
          left: 7px;
          top: 11px;
          width: 10px;
          height: 2px;
        }
      }
      &:hover {
        &:before {
          display: none;
        }
      }
    `}
`;